import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {getVideoId} from 'helpers/game-helper';
import {getText} from 'helpers/text-helper';
import YouTube from 'react-youtube';
import './game-step-video.scss';

const GameStepVideo = ({languageId, deviceInfo, gameStepData, groupData, goToNextGameStep}) => {
	/* Video state and ref */
	const [videoState, setVideoState] = useState('loading');
	const [videoRef, setVideoRef] = useState(null);

	const {videoId, thumbnail} = getVideoId(languageId, gameStepData, groupData);

	/**
	 * Start video
	 * @param {object} e 
	 * @returns 
	 */
	const handlePlay = (e) => {
		e.stopPropagation();
		if (videoState === 'loading') return;
		if (videoRef && videoRef.playVideo) {
			setVideoState('buffering');
			videoRef.playVideo();
		}
	};

	/**
	 * Video ended
	 */
	const videoEnded = () => {
		setVideoState('ended');
		goToNextGameStep();
	};

	return (
		<div className={'GameStepVideo ' + deviceInfo.orientation}>
			<div className="GameStepVideo-title">
				<span>{getText(gameStepData.title, languageId)}</span>
			</div>
			{videoId && 
				<div className={'GameStepVideo-videoWrap ' + thumbnail}>
					<YouTube 
						className={'GameStepVideo-video ' + videoState} 
						videoId={videoId} 
						onReady={(e) => {setVideoRef(e.target); setVideoState('ready');}}
						onPlay={() => {setVideoState('playing');}}
						onPause={() => {setVideoState('paused');}}
						onEnd={() => {videoEnded();}}
						opts={{
							height: '100%', 
							width: '100%', 
							playerVars: {
								controls: 1,
							}
						}}
					/>
					<div 
						className={'GameStepVideo-videoPlayBtn ' + videoState} 
						onClick={(e) => {handlePlay(e);}} 
					/>
				</div>
			}
		</div>
	);
};

GameStepVideo.propTypes = {
	languageId: PropTypes.string.isRequired,
	deviceInfo: PropTypes.object.isRequired,
	gameStepData: PropTypes.object.isRequired,
	groupData: PropTypes.object.isRequired,
	goToNextGameStep: PropTypes.func.isRequired
};

export default GameStepVideo;